import React from "react";

// redux
import { connect } from "react-redux";
import {
  createFuelTracker,
  clearFuelTrackerStates,
} from "../actions/fuelTracker"

// components
import AbstractPage from "./AbstractPage";
import FormGroupTextField from "./components/formGroupField";
import FormGroupDropdown from "./components/formGroupDropdown";

import toastr from 'toastr'

class FuelTracker extends AbstractPage {
  constructor(props) {
    super(props);
    this.title = "Fuel Tracker";
    this.state = {
      country: "",
      date: "",
      vehicle: "",
      odometer: "",
      fuelSource: "",
      location: "",
      comment: "",
      errorField: "",
    }

    this.countries = [
      "Australia",
      "Brazil",
      "Canada",
      "Chile",
      "China",
      "England",
      "Finland",
      "Ghana",
      "India"
    ]
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.updateSuccess) {
      this.props.clearStates()

      toastr.success('Fuel Tracker is create.', 'Fuel Tracker')
    }
  }

  onSubmit(){
    var errorField = ""
    if(this.state.country === "") {
      errorField = "country"
    }
    else if(this.state.date === "") {
      errorField = "date"
    }
    else if(this.state.vehicle === "") {
      errorField = "vehicle"
    }
    else if(this.state.odometer === "") {
      errorField = "odometer"
    }
    else if(this.state.fuelSource === "") {
      errorField = "fuelSource"
    }
    else if(this.state.location === "") {
      errorField = "location"
    }

    this.setState({
      errorField: errorField
    })

    if(errorField !== "") {
      return
    }

    const data = {
      country: this.state.country,
      date: this.state.date,
      vehicle: this.state.vehicle,
      odometer: this.state.odometer,
      fuel_source: this.state.fuelSource,
      refuel_location: this.state.location,
      comments: this.state.comment,
    }
    this.props.createFuelTracker(data)

    this.setState({
      country: "",
      date: "",
      vehicle: "",
      odometer: "",
      fuelSource: "",
      location: "",
      comment: "",
      errorField: "",
    })
  }

  onTextChange(name, value) {
    const newState = { ...this.state };
    newState[name] = value; // set value dynamically, make sure names are unnique
    this.setState(newState);
  };

  updateCell(oldValue, newValue, row, column) {
    if(oldValue === newValue) {
      return
    }
    this.props.updateFuelTracker(row.id, row)
  }

  render() {
    const {
      country,
      vehicle,
      date,
      odometer,
      fuelSource,
      location,
      comment,
      errorField,
    } = this.state;

    return (
      <div className="container container-p-y">
        <div className="card mb-4">
          <div className="card-body">
            <div className="form-row">
              <FormGroupDropdown
                label="Country *"
                value={country}
                placeholder="Country"
                onChange={this.onTextChange.bind(this)}
                width="4"
                name="country"
                options={this.countries}
                error={errorField === "country"}
              />
              <FormGroupTextField
                label="Date *"
                type="date"
                value={date}
                placeholder="mm/dd/yyyy"
                onChange={this.onTextChange.bind(this)}
                width="4"
                name="date"
                error={errorField === "date"}
              />
              <FormGroupDropdown
                label="Vehicle *"
                value={vehicle}
                placeholder=""
                onChange={this.onTextChange.bind(this)}
                width="4"
                name="vehicle"
                options={ ["Hire Vehicle", "Private Vehicle", "Third Party Vehicle"] }
                error={errorField === "vehicle"}
              />
              <FormGroupTextField
                label="Odometer Reading (km) *"
                value={odometer}
                type="number"
                placeholder="Odometer Reading (km) *"
                onChange={this.onTextChange.bind(this)}
                width="4"
                name="odometer"
                error={errorField === "odometer"}
              />
              <FormGroupDropdown
                label="Fuel Source *"
                value={fuelSource}
                placeholder=""
                onChange={this.onTextChange.bind(this)}
                width="8"
                name="fuelSource"
                options={ ["Service Station", "Drum/Tank"] }
                error={errorField === "fuelSource"}
              />
              <FormGroupTextField
                label="Refuel Location *"
                value={location}
                placeholder="Refuel Location"
                onChange={this.onTextChange.bind(this)}
                width="12"
                name="location"
                error={errorField === "location"}
              />
              <FormGroupTextField
                label="Comments"
                value={comment}
                placeholder="Comments"
                onChange={this.onTextChange.bind(this)}
                width="12"
                name="comment"
                textarea // this make this field a text area instead of textfield
              />
            </div>
            <button
              type="button"
              className="btn btn-md btn-outline-primary"
              onClick={this.onSubmit.bind(this)}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    updateSuccess: state.fuelTracker.updateSuccess,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    createFuelTracker: (data) => {
      dispatch(createFuelTracker(data))
    },
    clearStates: () => {
      dispatch(clearFuelTrackerStates())
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FuelTracker);



// WEBPACK FOOTER //
// ./src/views/FuelTracker.js